import { Car } from "lucide-react";

export function Logo({ className = "", size = 28, showText = true, dark = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div
        className="grid place-items-center rounded-xl bg-emerald-500 text-white shadow-sm shadow-emerald-500/30"
        style={{ width: size + 8, height: size + 8 }}
      >
        <Car size={size} strokeWidth={2.2} />
      </div>
      {showText && (
        <span className={`font-display text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-zinc-950"}`}>
          Vec<span className="text-emerald-500">Padi</span>
        </span>
      )}
    </div>
  );
}
